import type { FC } from 'react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { FormDesktop as Form } from '@alfa-bank/site-form/desktop';
import type { FormApi } from 'final-form';
import type { IProps as IFormProps } from '@alfa-bank/site-form/src/models';
import { finishOrderRequest } from '@alfa-bank/site-dc-form-api/store';

import { deliveryStepAnalytics as analytics } from './analytics';
import type { IDeliveryStepFormValues, TDeliveryStep } from './models';

export const DeliveryStep: FC<TDeliveryStep> = ({ DeliveryStepForm, ...deliveryStepProps }) => {
    const dispatch = useDispatch();
    const onSubmit = (formRef: HTMLFormElement, form: FormApi<IDeliveryStepFormValues>) => {
        const { brokerageAccountRequired, codeWord, comment, deliveryType, selectedOffice } =
            form.getState().values;

        dispatch(
            finishOrderRequest({
                brokerageAccountRequired,
                codeWord,
                comment,
                deliveryType,
                selectedOffice: selectedOffice?.[0],
            })
        );
    };

    return (
        <Form
            analytics={{
                submit: analytics.submit.success,
                submitOnFail: analytics.submit.fail,
            }}
            dataTestId="dc-form-second-step"
            onSubmit={onSubmit as unknown as IFormProps['onSubmit']}
            showFormOuterWrapper={false}
        >
            <DeliveryStepForm {...deliveryStepProps} />
        </Form>
    );
};
